module.exports = __webpack_public_path__ + "img/img1.2af07634.jpg";